import React, { Component, Fragment } from "react";

import {
  Metric,
  Error,
  formatDateFromData,
  selectFormat,
  isDateFromDataInISOFormat,
} from "./../../../Utils/Utils.js";

import { PieChart, Pie, Cell } from "recharts";
import SharedSocialLineChart from "./../../LineGraphs/SharedSocialLineChart/SharedSocialLineChart";

const COLORS = ["#f4f4f4", "#fc6d52"];

class YouTube extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => {
    const data = this.childRef
      .getExportData()
      .data.map((e) => ({ ...e, name: e.full_date || e.date || e.name }));
    return {
      data: data,
      opts: {
        type: "chart",
        date: {
          name: "name",
          // overwrites the default settings for date only when the date is in ISO format
          defined: isDateFromDataInISOFormat(data),
          format: "YYYY-MM-DDThh:mm:ssZ",
          viewFormat: "YYYY-MM-DD",
        },
        values: ["current_value", "previous_value"],
      },
    };
  };

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    let preparedData = formatDateFromData(
      this.props.data.graph.map((e) => ({ ...e, name: e.full_date || e.name })),
      null,
      "name"
    );

    return (
      <Fragment>
        <div key={"stats"} className="row mb-4">
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Views</h6>
            <Metric {...data.stats.views} size={"md"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Minutes Viewed</h6>
            <Metric {...data.stats.minutes_viewed} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Net New Subs</h6>
            <Metric {...data.stats.net_new_subs} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Shares</h6>
            <Metric {...data.stats.shares} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Likes</h6>
            <Metric {...data.stats.likes} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Embeds</h6>
            <Metric {...data.stats.embeds} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Comments</h6>
            <Metric {...data.stats.comments} size={"sm"} />
          </div>

          <div className="col-6 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label m-0">% Completion</h6>
            <PieChart height={45} width={45} startAngle={90}>
              <Pie
                dataKey="value"
                data={data.stats.complete}
                outerRadius="100%"
                innerRadius="75%"
              >
                {data.stats.complete.map((entry, index) => (
                  <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="piechart-metric__xsmall"
              >
                {selectFormat("percentage", data.stats.complete[1].value / 100)}
              </text>
            </PieChart>
          </div>
        </div>
        <SharedSocialLineChart
          ref={(el) => (this.childRef = el)}
          data={preparedData}
          color={"#fc6d52"}
        />
      </Fragment>
    );
  }
}
export default YouTube;
